import { checklist_userService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, checklist_users: [], checklist_user: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        checklist_userService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        checklist_userService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/checklist_users');
                    dispatch('alert/success', "Checklist User Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/checklist_users');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        checklist_userService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/checklist_users');
                    dispatch('alert/success', "Checklist User Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/checklist_users');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        checklist_userService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      checklist_userService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/checklist_users');
                  dispatch('alert/success', "Checklist User Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/checklist_users');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_checklist_user_by_account({ dispatch, commit }, data) {
        commit('request');

        checklist_userService.get_checklist_user_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  checklist_users: state => {
    return state.checklist_users
  },
  checklist_user: state => {
    return state.checklist_user
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.checklist_user = {};
        state.checklist_users = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.checklist_user = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.checklist_users = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const checklist_users = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
